export const similarGoods = {
  goodsExposure: '9580.0', // 来源商品曝光
  goDetail: 'n.4615.9581.0', // 来源商品-跳转详情点
  goodsPlusCart: '9595.0', // 加购物车点击
  similarGoodsExposure: '9594.0', // 同类商品曝光
  similarGoodsGoDetail: 'n.4615.9596.0', // 同类商品-跳转详情点击
  similarGoodsPlusCart: '9597.0', // 同类商品-加购物车点击
  recommendGoodsExposure: '9590.0', // 底部推荐商品曝光
  recommendGoodsGoDetail: 'n.4615.9591.0', // 底部推荐商品-跳转详情点击
  recommendGoodsPlusCart: '9592.0', // 底部推荐商品-加购物车点击
  goBack: '8969.0', // 返回按钮点击
  goShopCart: '8970.0' // 悬浮购物车点击
}
